import { render, staticRenderFns } from "./archives.vue?vue&type=template&id=3a0415ed&scoped=true&"
import script from "./archives.vue?vue&type=script&lang=js&"
export * from "./archives.vue?vue&type=script&lang=js&"
import style0 from "./archives.vue?vue&type=style&index=0&id=3a0415ed&prod&lang=scss&scoped=true&"
import style1 from "./archives.vue?vue&type=style&index=1&id=3a0415ed&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0415ed",
  null
  
)

export default component.exports